import React, { Component } from 'react'
import { Row, Column } from '../../global/grid/grid'
import { scaleLinear } from 'd3-scale'
import { line, curveBasis } from 'd3-shape'

class Bumpometer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      pathData: null,
      translateData: 0
    }

    this.defaultTranslateData = 10
    this.lineData = [0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5]
    this.fps = 50
    this.speed = 45
    this.now
    this.then = Date.now()
    this.interval = 1000 / this.fps
    this.delta

    this.valley = false
    this.oldLineData = null
    this.moveLine = this.moveLine.bind(this)
    this.drawLine = this.drawLine.bind(this)
    this.lineDataBuild = this.lineDataBuild.bind(this)

    this.xScale = null
    this.yScale = null
    /* this.xScale = scaleLinear()
      .domain([0, 20 - 1])
      .range([0, 180]);

    this.yScale = scaleLinear()
      .domain([0, 1])
      .range([100, 0]); */
  }
  newLineDataArray (newPoint) {
    let lineData = this.lineData
    lineData.shift()
    lineData.push(newPoint)
    return lineData
  }
  componentDidMount () {
    this.xScale = scaleLinear()
      .domain([0, 20 - 1])
      .range([0, 180])

    this.yScale = scaleLinear()
      .domain([0, 1])
      .range([100, 0])

    this.drawLine()
  }
  lineDataBuild () {
    const { currentStage, lineData } = this.props
    let limiter = 0.6
    if (lineData && !this.valley && this.oldLineData !== lineData) {
      this.lineData = this.newLineDataArray(lineData)
      this.oldLineData = lineData
      this.valley = true
    } else if (this.valley) {
      this.lineData = this.newLineDataArray(1 - this.oldLineData)
      this.valley = false
    } else {
      this.lineData = this.newLineDataArray(limiter - (Math.random() * 0.2)/*  - (currentStage/4) */)
      this.oldLineData = null
    }
    this.drawLine()
  }
  drawLine () {
    const lineData = this.lineData
    const path = line()
      .x((d, i) => { return this.xScale(i) })
      .y((d, i) => { return this.yScale(d) })
      .curve(curveBasis)

    this.setState({
      pathData: path(lineData),
      translateData: 10
    })
    this.moveLine()
  }
  moveLine () {
    this.now = Date.now()
    this.delta = this.now - this.then

    if (this.delta > this.interval && this.refs.bumpPath) {
      this.then = this.now - (this.delta % this.interval)
      this.setState({
        translateData: this.state.translateData + (Math.round((this.speed / this.fps) * 100) / 100)
      })
    }
    if (this.state.translateData < 10 + this.defaultTranslateData) {
      requestAnimationFrame(this.moveLine)
    } else {
      this.lineDataBuild()
    }
  }
  render () {
    const { label, isMobile } = this.props
    return (
      <div className='bumpometer'>
        <div className='bumpometerCopy'>{ label }</div>
        <svg
          id='first'
          width='150'
          height='150'
          fill='none'
        >
          <g transform={`translate(-${this.state.translateData + 10}, 0)`}>
            <path ref='bumpPath' id='bumpPath' d={this.state.pathData} stroke='#fff' strokeWidth={`${isMobile ? '5px' : '3px'}`} fill='none' />
          </g>
          <rect width='150' height='10' x='0' y='45' fill='white' style={{ opacity: '0.3' }} />
        </svg>
      </div>
    )
  }
}

export default Bumpometer



// WEBPACK FOOTER //
// ./src/components/modules/HomeHero/Bumpometer.js